<script>
    export default {
        props: ['opp', 'oppTypeMap'],
        mounted () {   

        },
        data() {
            return {
                showDesc: false,
            }
        },
        methods: {   
         
        }     
    }
</script>



<template lang="pug">

.oppcard
  .row 
    .col.s10
      span.opp-title(@click="showDesc = !showDesc") {{opp.title}} | {{oppTypeMap[opp.type_code]}}
  .row.opp-details
    | Contact: 
    b
      span.opp-contact {{opp.contactName}} | 
    span.opp-number {{opp.contactPhone}} | 
    span.opp-email {{opp.contactEmail}}
  .opp-description(v-if="showDesc") {{opp.description}}
  hr    

</template>



<style lang="sass" scoped>
.opp-description 
  font-size: 12px;
  padding: .5em 0 .5em 0;


.oppcard
  font-size: 15px;

.row .col
  padding: 0

#opps 
  padding: .5em;

.opps-container, .intro-container 
    padding: 0 1em 0 1em;

#company-img
  padding: 0;


#name
  margin-top: 0;


#search-hdr h5 
  padding-top: 1em;


#search-hdr p 
  padding-bottom: 1em;


.input-div.opp-title 
  color: #000 !important;
  font-weight: normal !important;


.opp-title 
  color: #1589FF;
  font-weight: bold;


.opp-details 
  font-size: 14px; 

#no-info span, #no-opps span 
  font-size: 12px;
  color: #bbbbbb;
</style>